import { Container, Grid } from "@material-ui/core";
import MaterialTable, { Column, Action } from "material-table";
import React, { useEffect, useState } from "react";
import { navigate } from "gatsby";
import { Fragment } from "react";
import { Dataset, Project } from "src/api/models";
import { any } from "prop-types";

const DatasetsViewer: React.FC<any> = ({ theme, project, datasets }) => {
  // if (!project || !datasets) return <Fragment />;
  //
  // datasets = [
  //   {
  //     name: "Bialis Source Dataset",
  //     desc: "Test Dataset",
  //     status: "Processed",
  //   },
  //   {
  //     name: "Family Creation Run 1",
  //     desc: "Process Test",
  //     status: "Processed",
  //   },
  // ];

  return (
    <MaterialTable
      title="Datasets"
      options={{
        grouping: false,
        showTitle: true,
        actionsColumnIndex: -1,
        // filtering: true,
        exportButton: true,
        // columnsButton: true,
        exportAllData: true,
        paging: false,
        headerStyle: {
          fontSize: "12px",
          fontWeight: "bold",
          padding: "3px 10px",
          whiteSpace: "nowrap",
          textTransform: "capitalize",
          zIndex: 0,
        },
        rowStyle: {
          fontSize: "13px",
        },
      }}
      actions={[
        {
          icon: "arrow_forward",
          tooltip: "View Project",
          onClick: (event, rowData) => {
            navigate(`/portal/dataset/${rowData.id}/project/${project.id}`);
          },
        },
      ]}
      columns={[
        { title: "Name", field: "name" },
        { title: "Description", field: "desc" },
        { title: "Status", field: "status" },
        // {
        //   title: "Params",
        //   render: (rowData) => {
        //     return rowData.paramJson;
        //   },
        // },
      ]}
      data={datasets}
      parentChildData={(row, rows) => {
        for (let i = 0; i < row.sourceDatasets.length; i++) {
          let source = row.sourceDatasets[i];
          console.log(source);
          let result = rows.find((a) => a.id === source);
          if (result !== undefined) return result;
        }
        return undefined;
      }}
    />
  );
};

export default DatasetsViewer;
